<template>
  <div class="leaderboard-mobile-secondary is-hidden-tablet">
    <ins style="display:block;" class="leaderboard__ad__mobile adsbygoogle leaderboard" data-ad-client="ca-pub-2580109990739065" data-ad-slot="4452569221" data-ad-format="auto" data-full-width-responsive="true"></ins>
  </div>
</template>

<script>
  export default {
    props: {
      wait: {
        type: Boolean,
        default: false
      },
      waitLonger: {
        type: Boolean,
        default: false
      }
    },
    data: () => ({
      record: {}
    }),
    mounted () {
      // fetch ad from api
      // if no result, display google - delayed
      try {
        if (this.waitLonger) {
          setTimeout((window.adsbygoogle = window.adsbygoogle || []).push({}), 1000)
        } else if (this.wait) {
          setTimeout((window.adsbygoogle = window.adsbygoogle || []).push({}), 800)
        } else {
          setTimeout((window.adsbygoogle = window.adsbygoogle || []).push({}), 500)
        }
      } catch (err) {
        console.log('error trying to push mobile secondary ad for Google')
      }
    }
  }
</script>

<style>
  .leaderboard-mobile-secondary {
    margin: auto;
  }

  .leaderboard {
    margin: 20px auto 20px auto;
  }

  .leaderboard__ad__mobile {
    display: block;
    width: 320px;
    height: 50px;
  }
</style>



// WEBPACK FOOTER //
// src/components/LeaderBoardMobileSecondary.vue